import React from 'react';
import isMobile from 'ismobilejs';
import { connect } from 'react-redux';
import { guardarDatosAsistido } from './service.act';
import { callService, formatPhone, formatDate, formatRamo, goTo } from '../tools';

import CompletarForm from './completar.frm.js';

const mapState = (state) => {
	let poliza = state.registro.poliza;
	if (state.registro.configuracion.sistema == "INFO") {
		while (poliza.length < 14) {
			poliza = "0" + poliza;
		}
	}

	return {
		"loading": state.global.loading,
		"ramo": state.registro.ramo,
		"poliza": poliza,
		"certificado": state.registro.certificado,
		"vigencia": state.registro.inicioVigenciaPolizaDate,
		"email": state.registro.email,
		"nacimientoFecha": state.registro.fecha_nacimiento_date,
		"lada_fijo": state.registro.ladaFijo,
		"lada_movil": state.registro.ladaCelular,
		"telefono_fijo": state.registro.telFijo,
		"telefono_movil": state.registro.telCelular,
		"avisoAceptado": state.registro.avisoAceptado,
		"mediosElectronicos": state.registro.mediosElectronicos
	};
};

const mapDispatch = (dispatch) => {
	return {
		loader: (show) => {
			dispatch({ "type": "LOADER", "show": show });
		},
		alerta: (sCode) => {
			dispatch({ "type": "MODAL_ALERT_CODE_SHOW", "codigo": sCode });
		},
		siguientePasoRegistro: () => {
			dispatch({ "type": "REGISTRO_PASO_SIGUIENTE" });
		},
		siguientePasoAsistido: () => {
			dispatch({ "type": "REGISTRO_ASISTIDO_SIGUIENTE_PASO" });
		},
		registrarDatos(sPaterno, sMaterno, sNombres) {
			dispatch(guardarDatosAsistido(sPaterno, sMaterno, sNombres))
		}
	}
}

class Completar extends React.Component {

	getHerramienta = () => {
		return (isMobile.any == true) ? "APP" : "PORTAL";
	}

	submit = (data) => {
		let $this = this;
		let herramienta = this.getHerramienta();

		$this.props.loader(true);
		$this.props.registrarDatos(data.apaterno, data.amaterno, data.nombres);

		let llamaServicio = new callService({
			service: 'registro.datosAsistidos',
			secure: true,
			data: {
				ramo: formatRamo(this.props.ramo),
				poliza: this.props.poliza,
				certificado: this.props.certificado,
				vigencia: formatDate(this.props.vigencia),
				email: this.props.email,
				nacimientoFecha: formatDate(this.props.fecha_nacimiento_date),
				ladaFijo: formatPhone(this.props.lada_fijo),
				ladaMovil: formatPhone(this.props.lada_movil),
				telefonoFijo: this.props.telefono_fijo,
				telefonoMovil: this.props.telefono_movil,
				apaterno: data.apaterno,
				amaterno: data.amaterno,
				nombres: data.nombres,
				herramienta: herramienta,
				avisoAceptado: this.props.avisoAceptado,
				mediosElectronicos: this.props.mediosElectronicos
			}
		}).execute().then((respuesta) => {
			console.log("Respuesta", respuesta);
			$this.props.loader(false);

			if (respuesta.registrarClienteResponse.banExito) {
				$this.props.siguientePasoRegistro();

				if (herramienta == "PORTAL") {
					goTo("registro-completo");
					//window.location.href = '/#!/registro-completo';	
				} else {
					goTo(respuesta.url);
					//window.location.href = respuesta.url;
				}
			}
		}).catch((error) => {
			console.log("Error", error);
			$this.props.loader(false);

			if (error.message.codigoError == "REG005" || error.message.codigoError == "REG010") {
				$this.props.siguientePasoAsistido();
			} else {
				$this.props.alerta(error.message.codigoError);
			}
		});
	}

	render() {
		return <CompletarForm onSubmit={this.submit} />
	}
}

export default connect(mapState, mapDispatch)(Completar);


// WEBPACK FOOTER //
// ./src/registro-asistido/completar.cmpt.js